import './home.css';
import Footer from './footer';
import logo from '../assets/2.png';
import image from '../assets/home.png';
import minimal from '../assets/image3.png';
import planner from '../assets/image2.png';
import motivation from '../assets/image1.png';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate();

    return (
        <div className='home-layout'>
            <div className='home-container'>
                <div className='home-box' id='home-phones'>
                    <div className='homeIntro-box'>
                        <img src={logo} className='home-logo'/>
                        <button onClick={() => navigate('/installer')}>Try for free</button>
                    </div>
                    <div className='homeIntro-box'>
                        <img src={image} className='images' id='intro-image'/>
                    </div>
                </div>
                <div className='home-box' id='home-phones'>
                    <div className='image-box'>
                        <img src={minimal} className='screenImages' />
                    </div>
                    <div className='text-box'>
                        <h2>Keep it Minimal</h2>
                        <p>A clean, distraction-free space designed to help you think clearly.
                            Gibo keeps only what you need- so you can focus on ideas, not clutter.</p>
                    </div>
                </div>
                <div className='home-box' id='home-phones'>
                    <div className='text-box'>
                        <h2>Daily Motivations</h2>
                        <p>Stay inspired with visual motivation built into your day.
                         Photos and visuals add positivity and context, 
                         keeping you motivated to move forward.</p>
                    </div>
                    <div className='image-box'>
                        <img src={motivation} className='screenImages' />
                    </div>
                </div>
                <div className='home-box' id='home-phones'>
                    <div className='image-box'>
                        <img src={planner} className='screenImages' />
                    </div>
                    <div className='text-box'>
                        <h2>Be productive</h2>
                        <p>Turn plans into action with clear, visual Kanban boards.
                            Track progress at a glance and stay focused on what matters most.
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Home;